import React from "react";
import { Link } from "@quintype/components";
import { object, array, bool, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../../atoms/Headline";
import CustomStoryCard4 from "../../../molecules/CustomStoryCard4";
import More from "../../../atoms/More";
import { getSlug } from "../../../utils/utils";
import CollectionTitleWithArrow from "../../../atoms/CollectionTitleWithArrow";
import { staticTexts } from "../../../utils/Translate";

import "./organism1.m.css";

const Organism1 = ({
  collection,
  sections,
  showCollectionName,
  showLoadMoreButton,
  publisherAttributes,
  src,
  updatedFont = false,
  domainSlug
}) => {
  const stories =
    collection && collection.items ? collection.items.filter(item => item.type === "story").slice(0, 4) : null;
  const collectionSlug = getSlug(collection, sections, domainSlug);
  const headlineStyle = updatedFont ? `${publisherAttributes.lang}-story-headline` : "";

  const renderListStories =
    stories.length > 1 &&
    stories.slice(1, 3).map((item, index) => (
      <div
        styleName={`${stories.length > 3 ? "list-story " : "list-story custom-border"} ${
          index === 1 ? "no-border" : ""
        }`}
        key={index}
      >
        <Link key={index} href={item.story.url}>
          <Headline text={item.story.headline} headlineType={21} headerLevel={2} styleName={headlineStyle} />
        </Link>
      </div>
    ));

  return stories && stories.length > 0 ? (
    <div styleName="collection-wrapper" className="collection-wrapper">
      <div>
        {showCollectionName && (
          <CollectionTitleWithArrow
            collectionName={collection.name}
            collectionSlug={collectionSlug}
            headlineClassName="collection-name-arrow"
            updatedFont={updatedFont}
          />
        )}
        {stories[0] && (
          <div styleName="top-story">
            <CustomStoryCard4
              story={stories[0].story}
              headlineType={21}
              widths={[400]}
              updatedFont={updatedFont}
              src={src}
            />
          </div>
        )}
      </div>
      {renderListStories}
      {!showLoadMoreButton && stories.length > 3 && (
        <div styleName={`read-more-button ${publisherAttributes.lang === "en" ? "en-read-more-button" : ""}`}>
          <More type="read-more" collection={collection} text={staticTexts(publisherAttributes.lang).loadMore} />
        </div>
      )}
    </div>
  ) : null;
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], []),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    domainSlug: get(state, ["qt", "config", "domainSlug"], "")
  };
};

Organism1.propTypes = {
  collection: object,
  sections: array,
  showCollectionName: bool,
  showLoadMoreButton: bool,
  publisherAttributes: object,
  src: string,
  updatedFont: bool,
  domainSlug: string
};

export default connect(mapStateToProps)(Organism1);
